import React, { useEffect, useState } from 'react';
import { Button, Form, Input, message, Drawer } from 'antd';
import { useSelector } from 'troyfe';
import { SmsApi } from "gmrfid-service-user-api-client";
import Block from './style';
import { DrawerStyle } from '../style';

function FindPassword({ passVisible, setPassVisible }) {
  const [form] = Form.useForm();
  const [code, setCode] = useState(true);
  const [flag, setFlag] = useState(true);
  const [phoneText, setPhoneText] = useState('发送验证码');
  const [disabled, setDisabled] = useState(false);
  const userObj = JSON.parse(sessionStorage.getItem('user'));
  const { basicInformation } = useSelector((state) => state.app);
  const { user } = basicInformation?.userInf;

  const onClose = () => {
    setPassVisible(false);
  };

  /* 发送验证码 */
  const sendFn = (ss) => {
    if (form.getFieldValue('phone')) {
      SmsApi.sendUpdateLoginPwd({}).then((res) => {
        if (res && res.status === 200) {
          setFlag(false);
          const _timer = setInterval(() => {
            ss--;
            setPhoneText(`${ss}秒`);
            if (ss === 0) {
              clearInterval(_timer);
              setPhoneText('重新获取');
              setFlag(true);
            }
          }, 1000);
        }
      });
    }
  };

  useEffect(() => {
    form.setFieldsValue({
      phone: user?.phone,
    });
  }, []);

  const handleOk = () => {
    setCode(true);
    form
      .validateFields()
      .then((values) => {
        UserApi.updateLoginPwdPC({
          form: {
            password: values.alsoPassword,
            smsCode: values.smsCode,
          },
        })
          .then((res) => {
            if (res && res.status === 200) {
              message.success('密码重置成功');
              setTimeout(() => {
                setPassVisible(false);
              }, 500);
              setDisabled(true);
            }
          })
          .catch((err) => {})
          .finally((info) => {});
      })
      .catch((info) => {
        console.log('info', info);
      });
  };
  return (
    <Drawer
      title=""
      placement="right"
      size="large"
      onClose={onClose}
      visible={passVisible}
      className="drawerModal"
      destroyOnClose
    >
      <DrawerStyle>
        <div className="drawer-top">
          <h1>
            修改密码
            <div className="clear" onClick={onClose}>
              x
            </div>
          </h1>
        </div>
        <Block>
          <Form className="form" name="basic" form={form} onFinish={handleOk}>
            <Form.Item
              name="phone"
              label="手机号码"
              rules={[
                {
                  required: true,
                  // pattern: new RegExp(/^[1-9]\d{10}$/),
                  message: '请输入手机号',
                },
              ]}
            >
              <Input
                value={userObj?.phone}
                disabled
                size="large"
                // onPressEnter={handleOk}
                placeholder="请输入手机号"
                style={{ width: '100%' }}
              />
            </Form.Item>
            <Form.Item label="验证码" name="smsCode" rules={[{ required: code, message: '请输入验证码' }]}>
              <Input
                size="large"
                // onPressEnter={handleOk}
                placeholder="请输入验证码"
                disabled={disabled}
                style={{ width: '100%' }}
                addonAfter={
                  !disabled && (
                    <Button
                      style={{
                        color: '#fff',
                        background: flag ? '#44BB55' : '#999999',
                        cursor: flag ? 'pointer' : 'no-drop',
                        width: '100px',
                        height: '100%',
                      }}
                      type="text"
                      onClick={() => {
                        if (flag) {
                          if (!form.getFieldValue('phone')) {
                            setCode(false);
                            form.submit();
                          } else if (
                            // !/^\d{11}$/.test(form.getFieldValue('phone')) ||
                            !form.getFieldValue('phone')
                          ) {
                            message.warning('发送失败,请输入正确的手机号');
                          } else {
                            sendFn(60);
                          }
                        }
                      }}
                    >
                      {phoneText}
                    </Button>
                  )
                }
              />
            </Form.Item>
            <Form.Item
              name="password"
              label="新密码"
              rules={[
                {
                  required: true,
                  message: '请输入新密码',
                },
              ]}
            >
              <Input.Password
                size="large"
                type="password"
                disabled={disabled}
                placeholder="请输入新密码"
                style={{ width: '100%' }}
              />
            </Form.Item>
            <Form.Item
              name="alsoPassword"
              label="确认密码"
              rules={[
                {
                  required: true,
                  message: '两次密码不一致',
                  validator: (rule, value) => {
                    if (form.getFieldValue('password') === value) {
                      return Promise.resolve();
                    }
                    return Promise.reject(new Error('两次密码不一致'));
                  },
                },
              ]}
            >
              <Input.Password
                disabled={disabled}
                size="large"
                type="password"
                placeholder="请再输一次新设置的密码"
                style={{ width: '100%' }}
              />
            </Form.Item>
          </Form>
        </Block>
        {!disabled && (
          <div className="handle">
            <Button
              onClick={() => {
                onClose();
              }}
              className="cancel"
            >
              取消
            </Button>
            <Button
              className="confirm"
              type="primary"
              htmlType="submit"
              onClick={() => {
                form.submit();
              }}
            >
              保存
            </Button>
          </div>
        )}
      </DrawerStyle>
    </Drawer>
  );
}

export default FindPassword;
